// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const ConfigurationLogs = reactLazyRetry(
  () => import('./systemLogs/pages/ConfigurationLogs')
);

/**
 * Logs route definitions and metadata used by the application router and
 * permission-aware navigation (QuickLinks).
 */
export const logsRoutes = [
  {
    name: 'ConfigurationLogs',
    key: 'configurationLogs',
    path: DEFAULT_ROUTE_CONFIG?.configurationLogs?.path || 'system-logs',
    element: <ConfigurationLogs />,
    permission: 'Logs_configurationLogs',
  },
];
